import type { CreationVersion } from './types.js';

export const SHOW_EVENTS = ['opened', 'first-artifact', 'choice-offered', 'choice-skipped', 'activity-started', 'sound-enabled', 'ready'] as const;
export type ShowEvent = typeof SHOW_EVENTS[number];

/** Creator intent is separate from immutable published asset bindings. */
export interface WorkshopSelection {
  originVersion: number;
  slot: string;
  variantId: string;
  revision: number;
  actor: string;
  selectedAt: number;
  /** Fixed at finalization; a later revision remains pending. Cleared by a carry. */
  snapshotVersion?: number;
}
/** A saved choice a live revision could not keep; the creator is told by slot. */
export interface WorkshopCarryNotice {
  version: number;
  slot: string;
  variantId: string;
  reason: 'slot-gone' | 'variant-gone' | 'base-gone';
  at: number;
}
export interface WorkshopState {
  revision: number;
  showEvents?: Record<string, number>;
  selections: WorkshopSelection[];
  drafts: Record<string, string>;
  carryNotices?: WorkshopCarryNotice[];
  showCaptures?: Array<{ id: string; version: number; url: string; title: string; capturedAt: number }>;
}
export const emptyWorkshop = (): WorkshopState => ({ revision: 0, selections: [], drafts: {} });
export const workshopDoc = (creationId: string): string => `creations/${creationId}/workshop/state`;
export const workshopSlot = (variant: { kind: string; name: string }): string => `${variant.kind}:${variant.name.toLowerCase()}`;
export function workshopSelectionStatus(selection: WorkshopSelection, active: Pick<CreationVersion, 'n' | 'assetsSnapshot'> | null, attached: ReadonlyArray<{ variantId: string }>, updating = false): 'selected' | 'applying' | 'applied' {
  // A cover is gallery art attached to the creation, never bound into a build.
  const applied = selection.slot.startsWith('cover:') ? attached : active?.assetsSnapshot;
  if (applied?.some(a => a.variantId === selection.variantId)) return 'applied';
  return selection.snapshotVersion && updating ? 'applying' : 'selected';
}
